/** MXCreditCardBALL 三页入口：regular / end / msi */
export type BallPageType = 'regular' | 'end' | 'msi';

export const BALL_PAGE_TYPE = {
    REGULAR: 'regular',
    END: 'end',
    MSI: 'msi'
} as const satisfies Record<string, BallPageType>;

/** 埋点 pub_page */
export const BALL_PUB_PAGE: Record<BallPageType, string> = {
    regular: 'card-regular',
    end: 'card-end',
    msi: 'card-msi'
};

/** 无 group_type 时的默认 ui_type */
export const BALL_DEFAULT_UI_TYPE: Record<BallPageType, string> = {
    regular: 'A',
    end: 'B',
    msi: 'C'
};
